import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { MuiBox, MuiIconButton, MuiTypography } from "components/atoms";
import React, { useState } from "react";
import AddIconImg from "assets/images/svg-icons/add-square.svg";
import MinusIconImg from "assets/images/svg-icons/minus-square.svg";
import { useSelector } from "react-redux";
import HelpTabSkeleton from "components/molecules/SkeletonLoaders/HelpTabSkeleton";
const HelpTab = () => {
  const [expanded, setExpanded] = useState(null);
  const { helpAndFeedback, helpAndFeedbackLoading } = useSelector(
    (state) => state.general,
  );

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  return (
    <MuiBox>
      {helpAndFeedbackLoading ? (
        <HelpTabSkeleton />
      ) : (
        // <MuiBox sx={{ py: "50px" }}>
        //   <CustomLoader />
        // </MuiBox>
        <MuiBox>
          <MuiBox
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              p: "20px",
            }}
          >
            {helpAndFeedback?.list?.map((item, index) => (
              <Accordion
                key={index}
                expanded={expanded === index}
                onChange={handleChange(index)}
                sx={{
                  bgcolor: "background.blue200",
                  boxShadow: "none",
                  borderRadius: "5px",
                  border: 0,
                  my: 0,
                  "&::before": {
                    display: "none",
                  },
                  "&.Mui-expanded": {
                    my: 0,
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <MuiIconButton
                      src={expanded === index ? MinusIconImg : AddIconImg}
                      alt="expandIcon"
                      size="24px"
                    />
                  }
                >
                  <MuiTypography
                    color={"text.darkBlack"}
                    fontWeight={400}
                    variant="14"
                  >
                    {item.title}
                  </MuiTypography>
                </AccordionSummary>
                {item.content && (
                  <AccordionDetails>
                    <MuiTypography
                      color={"text.gray900"}
                      fontWeight={400}
                      variant="14"
                    >
                      {item.content}
                    </MuiTypography>
                  </AccordionDetails>
                )}
              </Accordion>
            ))}
          </MuiBox>
          {/* <MuiBox
            sx={{
              display: "flex",
              gap: "12px",
              bgcolor: "background.gray200",
              p: "16px 20px",
              justifyContent: "end",
              flexWrap: { xs: "wrap-reverse", sm: "nowrap" },
            }}
          >
            <Button
              variant="whiteContained"
              sx={{
                width: "fit-content",
                border: "2px solid",
                borderColor: "background.blue600",
              }}
              onClick={() => dispatch(closeCenterModal())}
            >
              {t("commonButton.cancel")}
            </Button>
          </MuiBox> */}
        </MuiBox>
      )}
    </MuiBox>
  );
};

export default HelpTab;
